import React, { createContext, useContext, useState, useEffect } from 'react';
import { useGeneralSettings } from './GeneralSettingsContext';

const DiaporamaSettingsContext = createContext();

export const DiaporamaSettingsProvider = ({ children }) => {
  const { generalSettings, loadingSettings } = useGeneralSettings();

  // États initialisés avec les valeurs générales
  const [fontColor, setFontColor] = useState(generalSettings.fontColor);
  const [bgColor, setBgColor] = useState(generalSettings.bgColor);
  const [fontFamily, setFontFamily] = useState(generalSettings.fontFamily);
  const [fontSize, setFontSize] = useState(generalSettings.fontSize);
  const [backgroundImage, setBackgroundImage] = useState(generalSettings.backgroundImage);
  const [showScanMe, setShowScanMe] = useState(generalSettings.showScanMe);
  const [scanInterval, setScanInterval] = useState(generalSettings.scanInterval);
  const [transitionSpeed, setTransitionSpeed] = useState(generalSettings.transitionSpeed);
  const [showQrCorner, setShowQrCorner] = useState(generalSettings.showQrCorner);
  const [qrCornerPosition, setQrCornerPosition] = useState(generalSettings.qrCornerPosition);
  const [qrCornerSize, setQrCornerSize] = useState(generalSettings.qrCornerSize);
  const [bannerEnabled, setBannerEnabled] = useState(generalSettings.bannerEnabled);
  const [bannerPosition, setBannerPosition] = useState(generalSettings.bannerPosition);
  const [bannerText, setBannerText] = useState(generalSettings.bannerText);
  const [bannerShowBackground, setBannerShowBackground] = useState(generalSettings.bannerShowBackground);
  const [bannerBgColor, setBannerBgColor] = useState(generalSettings.bannerBgColor);
  const [bannerTextColor, setBannerTextColor] = useState(generalSettings.bannerTextColor);
  const [bannerFontSize, setBannerFontSize] = useState(generalSettings.bannerFontSize);
  const [animationType, setAnimationType] = useState(generalSettings.animationType);
  const [animationEnabled, setAnimationEnabled] = useState(generalSettings.animationEnabled);
  const [watermarkEnabled, setWatermarkEnabled] = useState(generalSettings.watermarkEnabled);

  // Mettre à jour les états quand generalSettings change (chargement initial)
  useEffect(() => {
    if (!loadingSettings) {
      setFontColor(generalSettings.fontColor);
      setBgColor(generalSettings.bgColor);
      setFontFamily(generalSettings.fontFamily);
      setFontSize(generalSettings.fontSize);
      setBackgroundImage(generalSettings.backgroundImage);
      setShowScanMe(generalSettings.showScanMe);
      setScanInterval(generalSettings.scanInterval);
      setTransitionSpeed(generalSettings.transitionSpeed);
      setShowQrCorner(generalSettings.showQrCorner);
      setQrCornerPosition(generalSettings.qrCornerPosition);
      setQrCornerSize(generalSettings.qrCornerSize);
      setBannerEnabled(generalSettings.bannerEnabled);
      setBannerPosition(generalSettings.bannerPosition);
      setBannerText(generalSettings.bannerText);
      setBannerShowBackground(generalSettings.bannerShowBackground);
      setBannerBgColor(generalSettings.bannerBgColor);
      setBannerTextColor(generalSettings.bannerTextColor);
      setBannerFontSize(generalSettings.bannerFontSize);
      setAnimationType(generalSettings.animationType);
      setAnimationEnabled(generalSettings.animationEnabled);
      setWatermarkEnabled(generalSettings.watermarkEnabled);
    }
  }, [loadingSettings, generalSettings]);

  return (
    <DiaporamaSettingsContext.Provider
      value={{
        fontColor, setFontColor,
        bgColor, setBgColor,
        fontFamily, setFontFamily,
        fontSize, setFontSize,
        backgroundImage, setBackgroundImage,
        showScanMe, setShowScanMe,
        scanInterval, setScanInterval,
        transitionSpeed, setTransitionSpeed,
        showQrCorner, setShowQrCorner,
        qrCornerPosition, setQrCornerPosition,
        qrCornerSize, setQrCornerSize,
        bannerEnabled, setBannerEnabled,
        bannerPosition, setBannerPosition,
        bannerText, setBannerText,
        bannerShowBackground, setBannerShowBackground,
        bannerBgColor, setBannerBgColor,
        bannerTextColor, setBannerTextColor,
        bannerFontSize, setBannerFontSize,
        animationType, setAnimationType,
        animationEnabled, setAnimationEnabled,
        watermarkEnabled, setWatermarkEnabled
      }}
    >
      {children}
    </DiaporamaSettingsContext.Provider>
  );
};

export const useDiaporamaSettings = () => {
  const context = useContext(DiaporamaSettingsContext);
  if (!context) {
    throw new Error('useDiaporamaSettings must be used within DiaporamaSettingsProvider');
  }
  return context;
};